export enum ClientAccountCourseRouteNames {
  ClientAccountCourseList = "clientAccountCourseList",
}
